import { Layout, SlideoutDecorator, SlideoutDecoratorProps } from "@mcleod/components";
import { Alignment } from "@mcleod/core";
import { Feasibility, FeasibilityProps } from "./Feasibility";
import { OrderPlanningToolPanel, Tools } from "../planning/OrderPlanningToolPanel";
import { RowActionFeasibility } from "../planning/calltoactions";



export class FeasibilitySlideout {

    constructor(props: FeasibilityProps, sldProps?: Partial<SlideoutDecoratorProps>) {
        this.slideUp(props, sldProps);
    }

    private slideUp(props: FeasibilityProps, sldProps?: Partial<SlideoutDecoratorProps>) {
        const layout = Layout.getLayout("lme/dispatch/asset/Feasibility") as Feasibility;
        new SlideoutDecorator({
            layout,
            title: "Load Feasibility",
            transitionOptions: { direction: Alignment.BOTTOM },
            displayOverlay: true,
            overlayProps: { closeOnClickOff: false, coverPageHeader: false },
            contentProps: { padding: 12 },
            fillHorizontalSpace: true,
            fillVerticalSpace: true,
            layoutLoadListeners: () => {
                layout.setup(props);
            },
            ...sldProps
        });
    }

    static slideUpForOrderPlanningToolPanel(orderToolsPanel: OrderPlanningToolPanel, sldProps?: Partial<SlideoutDecoratorProps>) {
        const { ordersRow, equipRow } = orderToolsPanel.getVisibleAction<RowActionFeasibility>(Tools.FEASIBILITY).getSelectedRowData();
        let originEarly: Date, destEarly: Date;
        let driverId: string = equipRow?.get("driver1_id");
        let linkedId: string;
        if (orderToolsPanel.isForOrderMoves()) {
            if (equipRow == null) {
                driverId = ordersRow?.get("driver1_id");
            }
            originEarly = ordersRow?.getDateTime("origin_early");
            destEarly = ordersRow?.getDateTime("destination_early");
            linkedId = ordersRow?.get("linked_id");
        } else {
            originEarly = equipRow.getDateTime("driver1_np_origin_early");
            destEarly = equipRow.getDateTime("driver1_np_dest_early");
        }
        const equipMoveId = equipRow?.get("movement_id");
        const availableMoveId = orderToolsPanel.isForEquipMoves() ? equipRow?.get("driver1_np_move_id") : ordersRow?.get("movement_id");
        new FeasibilitySlideout({
            driverId, availableMoveId, equipMoveId, originEarly, destEarly, linkedId
        }, sldProps);
    }

}
